import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';




 
import { Link } from 'react-router-dom';
import paymentService from "../../api/payment.service";














const PaymentPaidList = (props) => {
    const [paymentPaidList, setPaymentPaidList] = useState([]);




  const columns = [
    {
      title: 'First Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      
      
    },
    {
        title: 'Last Name',
        dataIndex: 'member_lname',
        key: 'member_lname',
        
        
      },
    {
      title: 'Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'Payment No',
      dataIndex: 'payment_no',
      key: 'payment_no',
    },
    {
      title: 'Payment Date',
      dataIndex: 'payment_date',
      key: 'payment_date',
    },
    {
      title: 'Total Payable',
      dataIndex: 'total_payble_amount',
      key: 'total_payble_amount',
    },
    {
        title: 'Paid Amount',
        dataIndex: 'payment_amount',
        key: 'payment_amount',
      },

      {
        title: 'Short/Excess',
        dataIndex: 'short_excess_amount',
        key: 'short_excess_amount',
      },
    
  
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        
        <Space size="middle">
    

         
          <Link to={`/payment/${selectedObj.payment_id}`} >
             
          
            <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>

          </Link>
        </Space>
      ),
    },
  ];


  useEffect(() => {
    const data = {
        formdata:{ programme_id:props.programme_id }
    }
    paymentService.paidPaymentList(data).then((res) => {
      console.log(res.data.response_data);
      setPaymentPaidList(res.data.response_data)
    });
  }, [props.programme_id])



  return (
    <>
      <Table columns={columns} rowKey='payment_id' dataSource={paymentPaidList} />
    </>
  );
};

export default PaymentPaidList